module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Book.813557d.otf";